// Background picker dialog. Replaces the old cycle-on-tap pill: tapping the menu's
// Background button opens a panel with one thumbnail card per backdrop, so the choice
// is visual (you see what you get) instead of blind cycling.
import i18next from 'i18next';
import { openChoicePicker } from './choicePicker';
import { BACKGROUNDS, type Background } from '@/game/storage';
import { fableVariant } from '@/game/theme';

// "space" is a procedural starfield in-game (no image asset), so its thumbnail is a
// small inline-SVG starfield; every other backdrop previews its real board image.
// "fable" previews the day/night variant the player would actually get right now.
function thumbHtml(bg: Background): string {
  if (bg === 'space') {
    const stars = [
      [12, 20, 1.6], [30, 62, 1.1], [45, 15, 1.3], [58, 48, 1.8], [72, 25, 1.2],
      [88, 55, 1.5], [105, 12, 1.1], [118, 40, 1.7], [135, 60, 1.2], [148, 22, 1.4],
      [20, 45, 1.0], [65, 70, 1.3], [95, 75, 1.0], [128, 78, 1.5], [150, 68, 1.0],
      [38, 80, 1.2], [80, 8, 1.0], [112, 66, 1.2],
    ].map(([x, y, r]) => `<circle cx="${x}" cy="${y}" r="${r}" fill="#dfe6ee"/>`).join('');
    return `<svg viewBox="0 0 160 90" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <rect width="160" height="90" fill="#0b0d18"/>${stars}</svg>`;
  }
  const asset = bg === 'fable' ? fableVariant() : bg;
  return `<img src="/images/background_${asset}.jpg" alt="" draggable="false">`;
}

export function openBackgroundPicker(current: Background, onSelect: (bg: Background) => void): void {
  openChoicePicker(
    i18next.t('menu.bgChoose'),
    BACKGROUNDS.map((bg) => ({ id: bg, tileHtml: thumbHtml(bg), name: i18next.t(`menu.bg.${bg}`) })),
    current,
    (id) => onSelect(id as Background),
  );
}
